
 /*Import Packages*/
import React, { Component, useEffect } from 'react';
import {BrowserRouter, Route, Redirect} from 'react-router-dom';

/*Import pages*/
import Login from './container/auth/login.js';
import Signup from './container/auth/signup.js';
import AdminLogin from './container/auth/adminLogin.js';

import Notifications from './container/notification/notification.js';
import Dashboard from './container/home/dashboard.js';
import AddNewBusiness from './container/addNewBusiness/main.js';
import CreateAds from './container/createAds/createAds.js';
import InvoiceListing from './container/invoice/listing.js';
import BusinessListing from './container/businessListing/businessListing.js';
import ProfileListing from './container/profile/profileListing.js';
import AdsPlans from './container/plans/adsPlans.js';
import CreateOffers from './container/createOffers/createOffers.js';
import ScheduledAds from './container/scheduledAds/adsList.js';
import Edit from './container/scheduledAds/edit.js';
import Slot from './container/scheduledAds/slot.js';
import AdType from './container/scheduledAds/ad-type.js';
import BannerStyle from './container/createAds/bannerStyle.js';
import BannerContent from './container/createAds/bannerContent.js';
import ManageProducts from './container/manageProducts/manageProjucts.js';
import ProductDetail from './container/manageProducts/product-detail.js';
import Enquires from './container/enquires/enquires.js';
import Store from './container/store/store.js';

// import OnlineLayoutsList from './container/online/layouts/layouts-list.js';
// import OnlineHomeLayout from './container/online/layouts/home.js';
// import VendorsList from './container/online/vendors/list.js';
// import VendorDetail from './container/online/vendors/detail.js';
// import UsersList from './container/online/users/list.js';
// import InvoiceList from './container/online/invoice/list.js';
// import SendNotification from './container/online/notification/send.js';
// import ScheduledAds from './container/online/scheduledAds/adsList.js';
// import CategorySettings from './container/online/category/list.js';

/*Import global components like header, footers*/
import Sidebar from './components/navigations/sidebar.js';
import Topbar from './components/navigations/topbar.js';



const ONESIGNAL_APP_ID = "fb494eb4-56cc-480f-9164-22e2ab55981a";
// const ONESIGNAL_WEB_ID = "web.onesignal.auto.195e7e66-9dea-4e11-b56c-b4a654da5ab7";

/* localhost test*/
// const ONESIGNAL_APP_ID = "b1f8a562-1ef7-4128-b97c-a4f01464e2bf";
// const ONESIGNAL_WEB_ID = "web.onesignal.auto.162dc776-ab2c-42c2-8206-1135116280d4";

const App = () => {
  window.OneSignal = window.OneSignal || [];
  const OneSignal = window.OneSignal;

  useEffect(() => {
    OneSignal.push(function () {
      OneSignal.init({
        appId: ONESIGNAL_APP_ID,
        // safari_web_id: ONESIGNAL_WEB_ID,
        // allowLocalhostAsSecureOrigin: true,
        notifyButton: {
          enable: true,
        },
      });
    });
  }, []);

  return (
    <AppChild />
  )
}
class AppChild extends Component {
  constructor(props){
    super(props);
    this.state = {
      sidebarCollaspse: false
    }
  }

  collapse(){
    this.setState({sidebarCollaspse: !this.state.sidebarCollaspse});
  }

  render() {
    if(localStorage.getItem("truekhoj_Vendor")){
      return(
        <section>
          {<BrowserRouter>
          <div className="container-fluid">
            {
              this.state.sidebarCollaspse ?
                <div className="row">
                  <div className="col-lg-1 e-sidebar-wrap p-0">
                    <Sidebar collapse={this.collapse.bind(this)}/>
                  </div>
                  <div className="col-lg-11 p-0">
                    <Topbar/>
                    <div>
                      <Route path="/notification" component={Notifications}/>
                      <Route path="/dashboard" component={Dashboard}/>
                      <Route path="/add-business" component={AddNewBusiness}/>
                      <Route path="/invoices" component={InvoiceListing}/>
                      <Route path="/business" component={BusinessListing}/>
                      <Route path="/profile" component={ProfileListing}/>
                      <Route path="/ads-plans" component={AdsPlans}/>
                      <Route path="/create-offers" component={CreateOffers}/>
                      <Route path="/scheduled-ads" component={ScheduledAds}/>
                      <Route path="/create-ads" component={CreateAds}/>
                      <Route path="/edit" component={Edit}/>
                      <Route path="/slot" component={Slot}/>
                      <Route path="/ad-type" component={AdType}/>
                      <Route path="/banner-style" component={BannerStyle}/>
                      <Route path="/banner-content" component={BannerContent}/>
                      <Route path="/manage-products" component={ManageProducts}/>
                      <Route path="/all-enquires" component={Enquires}/>
                      <Route path='/store-layout' component={Store}/>

                      {/*<Route path="/online-layouts" component={OnlineLayoutsList}/>
                      <Route path="/online-layout-home" component={OnlineHomeLayout}/>
                      <Route path="/vendors" component={VendorsList}/>
                      <Route path="/vendor-detail" component={VendorDetail}/>
                      <Route path="/invoices" component={InvoiceList}/>
                      <Route path="/push-notification" component={SendNotification}/>
                      <Route path="/scheduled-ads" component={ScheduledAds}/>
                      <Route path="/category-settings" component={CategorySettings}/>*/}
                    </div>
                  </div>
                </div>
              :
                <div className="row">
                  <div className="col-lg-2 e-sidebar-wrap p-0">
                    <Sidebar collapse={this.collapse.bind(this)}/>
                  </div>
                  <div className="col-lg-10 p-0">
                    <Topbar/>
                    <div>
                      <Route path="/notification" component={Notifications}/>
                      <Route path="/dashboard" component={Dashboard}/>
                      <Route path="/add-business" component={AddNewBusiness}/>
                      <Route path="/invoices" component={InvoiceListing}/>
                      <Route path="/business" component={BusinessListing}/>
                      <Route path="/profile" component={ProfileListing}/>
                      <Route path="/ads-plans" component={AdsPlans}/>
                      <Route path="/purchase-plans" component={AdsPlans}/>
                      <Route path="/create-offers" component={CreateOffers}/>
                      <Route path="/scheduled-ads" component={ScheduledAds}/>
                      <Route path="/create-ads" component={CreateAds}/>
                      <Route path="/edit" component={Edit}/>
                      <Route path="/slot" component={Slot}/>
                      <Route path="/ad-type" component={AdType}/>
                      <Route path="/banner-style" component={BannerStyle}/>
                      <Route path="/banner-content" component={BannerContent}/>
                      <Route path="/manage-products" component={ManageProducts}/>
                      <Route path="/product-detail" component={ProductDetail}/>
                      <Route path="/all-enquires" component={Enquires}/>
                      <Route path='/store-layout' component={Store}/>
                      <Route path="/admin-login" component={AdminLogin}/>
                      {/*<Route path="/online-layouts" component={OnlineLayoutsList}/>
                      <Route path="/online-layout-home" component={OnlineHomeLayout}/>
                      <Route path="/vendors" component={VendorsList}/>
                      <Route path="/vendor-detail" component={VendorDetail}/>
                      <Route path="/invoices" component={InvoiceList}/>
                      <Route path="/push-notification" component={SendNotification}/>
                      <Route path="/scheduled-ads" component={ScheduledAds}/>
                      <Route path="/category-settings" component={CategorySettings}/>*/}
                    </div>
                  </div>
                </div>
            }

          </div>
          </BrowserRouter>}
        </section>
      )
    }
    else{
      return(
        <React.Fragment>
          <BrowserRouter>
          <Route path="/" exact component={Login}/>
          <Route path="/signup" component={Signup}/>
          <Route path="/admin-login" component={AdminLogin}/>
          </BrowserRouter>
        </React.Fragment>
      )
    }

  }
}

export default App;
